


























































import Vue from 'vue';
import { formatDateTime, ShowFinally, Message } from 'mycorems-app-shared';
import {
  User, QueryResult, QueryFilters, QPagination, UserQueryFilters,
} from '../types';
import HasTaskMixin from '../components/HasTaskMixin';
import repository from './user-repository';
import UserStatus from './status/UserStatus.vue';
import UserRolesBtn from '../user-role/UserRolesBtn.vue';
import DeleteUserBtn from './DeleteUserBtn.vue';

interface Data {
  columns: object[],
  total: number,
  users: User[],
  task: Promise<QueryResult>|null,
  pagination: QPagination,
  keyword: string|null,
}

export default Vue.extend({
  components: {
    UserRolesBtn,
    UserStatus,
    DeleteUserBtn,
    ShowFinally,
    Message,
  },
  mixins: [HasTaskMixin],
  props: {
    accountId: {
      type: String,
      required: true,
    },
    searchable: {
      type: Boolean,
      default: false,
    },
  },
  data(): Data {
    return {
      columns: [
        {
          name: 'name',
          label: 'Name',
          field: (user: User) => `${user.firstName} ${user.lastName}`,
          align: 'left',
        },
        {
          name: 'email',
          label: 'Email',
          field: 'email',
          align: 'left',
        },
        {
          name: 'roles',
          label: 'Roles',
          align: 'center',
        },
        {
          name: 'status',
          label: 'Status',
          field: 'status',
          align: 'center',
        },
        {
          name: 'createdAt',
          label: 'Created',
          field: 'createdAt',
          align: 'left',
        },
        {
          name: 'actions',
          align: 'right',
        },
      ],
      total: 0,
      users: [],
      task: null,
      pagination: {
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 0,
      },
      keyword: null,
    };
  },
  watch: {
    accountId: {
      handler() {
        this.load();
      },
      immediate: true,
    },
    pagination: {
      handler(): void {
        this.load();
      },
      deep: true,
    },
    filters: {
      handler(): void {
        this.load();
      },
      deep: true,
    },
  },
  computed: {
    filters(): UserQueryFilters {
      return {
        keyword: this.keyword,
        offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
        limit: this.pagination.rowsPerPage,
      };
    },
  },
  methods: {
    remove(id: string): void {
      const index = this.users.findIndex(u => u.id === id);
      if (index >= 0) {
        this.users.splice(index, 1);
      }
    },
    deleteUser(id: string): void {
      this.remove(id);
    },
    load() {
      this.task = repository.findAll(this.accountId, this.filters);
      this.task.then((result: QueryResult) => {
        this.total = result.total;
        this.users = (result.items as User[]);
        this.pagination.rowsNumber = result.total;
      });
    },
    unshift(user: User) {
      this.total += 1;
      this.users.unshift(user);
    },
  },
  filters: {
    datetime: formatDateTime,
  },
});
